<template>
  <v-form ref="addSubscriptionForm"
          :disabled="isFormDisabled()"
  >
    <v-row>
      <v-col cols="12" sm="6" lg="3">
        <v-text-field
            v-model="details.planId"
            label="ID planu"
            :aria-required="true"
            disabled
        />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-text-field
            v-model="details.orderId"
            label="ID zamówienia"
            :aria-required="true"
            disabled
        />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-text-field
            v-model="periodFromFormatted"
            label="Okres od"
            :aria-required="true"
            disabled
        />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-text-field
            v-model="periodToFormatted"
            label="Okres do"
            :aria-required="true"
            disabled
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
            v-if="details.userId"
            class="mx-3"
            @click="goToUserDetails(details.userId)"
        >
          Przejdź do użytkownika
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn
            v-if="details.orderId"
            class="mx-3"
            @click="goToOrderDetails(details.orderId)"
        >
          Przejdź do zamówienia
        </v-btn>
      </v-col>
    </v-row>
    <modal-loader :show="loading"/>
  </v-form>
</template>

<script>
import api from "@/services/api";
import formatters from "@/mixins/formatters";
import ModalLoader from "@/components/ModalLoader";

export default {
  props: {
    id: {
      type: [String],
      required: false,
      default: null,
    },
  },
  components: {
    ModalLoader,
  },
  mixins: [
    formatters,
  ],
  data() {
    return {
      default: {},
      details: {
        userId: false,
        planId: null,
        orderId: null,
        periodFrom: null,
        periodTo: null,
      },
      label: {},
      rules: {},
      loading: false,
      saving: false,
    };
  },
  computed: {
    periodFromFormatted() {
      const ts = this.details.periodFrom ? this.details.periodFrom.timestamp : null

      if (!ts) {
        return ''
      }

      return this.localDateTime(ts)
    },
    periodToFormatted() {
      const ts = this.details.periodTo ? this.details.periodTo.timestamp : null

      if (!ts) {
        return ''
      }

      return this.localDateTime(ts)
    },
  },
  created() {
    if (this.id) {
      this.get();
    }
  },
  methods: {
    isIdle() {
      return !this.loading && !this.saving;
    },
    isFormDisabled() {
      return !this.isIdle();
    },
    isEditForm() {
      return !!this.id;
    },
    add() {

    },
    get() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      api.get(`/api/subscription/${this.id}`)
          .then((response) => {
            this.details = response.data;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać danych subskrypcji.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    goToOrderDetails(id) {
      this.$router.push({name: 'order-details', params: {id: id}})
          .catch((error) => {
            console.error('Error during redirection:', error);
          });
    },
    goToUserDetails(id) {
      this.$router.push({name: 'user-details', params: {id: id}})
          .catch((error) => {
            console.error('Error during redirection:', error);
          });
    },
  },
}
</script>